module.exports = __webpack_public_path__ + "static/media/liam.bda5c0bd.JPG";